import React from 'react';
import { Link } from 'react-router-dom';

export default function Breadcrumb({ items = [], className = '' }) {
  return (
    <nav className={`sf-breadcrumb w-full ${className}`} aria-label="breadcrumb">
      <div className="container-fluid">
        <div className="flex -mx-4 items-center justify-start flex-wrap">
          <Link className="bread-crumb__item" to="/">Home</Link>
          {items.map((it, i) => (
            <React.Fragment key={i}>
              <span className="sf__breadcrumb-separator py-2">
                <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M9 6l6 6-6 6" /></svg>
              </span>
              {it.url && i < items.length - 1 ? (
                <Link className="bread-crumb__item" to={it.url}>{it.label}</Link>
              ) : (
                <span className="sf__breabcrumb-page-title p-4">{it.label}</span>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </nav>
  );
}
